import {
  eachDayOfInterval,
  eachWeekOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  parse,
  startOfMonth,
  startOfWeek,
} from 'date-fns';

export type DateString = `${number}-${number}-${number}`;

export const stringToDateString = (possibleDateString: string): DateString =>
  format(parse(possibleDateString, 'yyyy-MM-dd', new Date()), 'yyyy-MM-dd') as DateString;

export const getSixWeekRange = (month: Date | DateString): Date[] => {
  const start = startOfMonth(month);
  const end = endOfMonth(month);

  const weeks = eachWeekOfInterval({ start, end }, { weekStartsOn: 1 });
  while (weeks.length < 6) {
    const latestWeek = new Date(weeks[weeks.length - 1]);
    latestWeek.setDate(latestWeek.getDate() + 7);
    weeks.push(latestWeek);
  }
  return weeks;
};

export const getWeekDays = () => {
  const today = new Date();
  return eachDayOfInterval({
    start: startOfWeek(today, { weekStartsOn: 1 }),
    end: endOfWeek(today, { weekStartsOn: 1 }),
  });
};
